<template>
  <div class="check-work-body">
    <div style="display: flex;flex-direction: row">
      <div style="width: 200px">
        <area-tree @nodeClick="nodeClick1"></area-tree>
      </div>
      <div>
        <div class="search-wrap">
          <el-button size="mini" type="primary" v-if="ERP.isPermission(26005001003003)" @click="editArticle(0)" style="margin-right: 5px;" icon="el-icon-plus">添加</el-button>

          是否自营：
          <el-select v-model="manage_type" filterable placeholder="选择分类" clearable size="mini">
            <el-option
              v-for="(item,index) in manage_typeList"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>

          分类：
          <el-select v-if="manage_type==1" v-model="search.type_id" filterable placeholder="选择分类" clearable size="mini">
            <el-option
              v-for="(item,index) in search.type_list"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
          战区：
          <el-select v-if="manage_type==1" v-model="search.region" placeholder="请选择战区" filterable clearable size="mini">
            <template v-for="item in search.region_list">
              <el-option :label="item.name" :value="item.id"/>
              <template v-for="sub in item.children">
                <el-option :label="'  - ' + sub.name" :value="sub.id" />
              </template>
            </template>
          </el-select>

          项目：
          <el-select v-if="manage_type==1" v-model="search.project" placeholder="请选择项目"  filterable clearable size="mini">
            <template v-for="(item,index) in search.project_list">
              <el-option :label="item.house_name" :value="item.erp_pindex_id"></el-option>
            </template>
          </el-select>

          项目名称：
          <el-input size="mini" placeholder="请输入搜关键字" v-model="keyword" clearable style="width: 200px"></el-input>
          <el-button size="mini" type="primary" @click="searchData">搜索</el-button>
          <div style="width: 30px;display: inline-block;"></div>
          <el-button size="mini" type="primary" v-if="ERP.isPermission(26005001003002)" @click="exportExcel">导出</el-button>
          <el-button size="mini" type="primary" v-if="ERP.isPermission(26005001003001)" @click="importExcel">导入</el-button>
        </div>

        <div class="table-wrap">
          <el-table v-if="pageData" v-loading="loading" :data="pageData.list">
<!--            <el-table-column prop="id" label="id" align="center"></el-table-column>-->
            <el-table-column prop="contract_area" label="所属区域" align="center" width="240"></el-table-column>
            <el-table-column prop="project_name" label="中奥项目名称" align="center" width="240"></el-table-column>
            <el-table-column label="类型" prop="manage_type" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.manage_type == 1">自营</span>
                <span v-if="scope.row.manage_type == 2">外拓</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="项目名称" align="center" width="180"></el-table-column>
            <el-table-column prop="number" label="项目编号" align="center" width="180"></el-table-column>
            <el-table-column prop="project_personnel_number" label="项目人数" align="center"></el-table-column>
            <el-table-column prop="tax_rate" label="税率(%)" align="center"></el-table-column>
            <el-table-column prop="service_area" label="服务面积" align="center"></el-table-column>
            <el-table-column prop="province_city" label="省市" align="center" width="180"></el-table-column>
            <el-table-column prop="address" label="项目地址" align="center" width="280"></el-table-column>
            <el-table-column prop="project_leader" label="项目负责人" align="center" width="180"></el-table-column>
            <el-table-column prop="mobilization_time" label="进场时间" align="center" width="180"></el-table-column>
            <el-table-column label="是否经营" align="center">
              <template slot-scope="scope">
                否
              </template>
            </el-table-column>
            <el-table-column prop="create_time" label="创建时间" align="center" width="180"></el-table-column>
            <el-table-column prop="update_time" label="修改时间" align="center" width="180"></el-table-column>
            <el-table-column label="操作" align="center" width="180">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" v-if="ERP.isPermission(26005001003004)" icon="el-icon-edit" @click="editArticle(scope.row)">修改</el-button>
<!--                <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteProject(scope.row)">删除</el-button>-->
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="pagination-wrap">
          <el-pagination background layout="prev, pager, next" :total="pageData.total*1" :page-size="pageData.pageSize*1" :current-page="pageData.page*1" @current-change="pageChange"></el-pagination>
        </div>
      </div>
    </div>



    <!-- 修改窗口 -->
    <el-dialog title="项目编辑" :visible.sync="dialogVisible" :close-on-click-modal="false" width="600px">

      <div style="max-height: 500px;overflow-y: auto;">
        <el-form :model="form" ref="form" label-width="100px" size="mini" style="margin-right: 50px;">
          <el-form-item label="项目名称" prop="title">
            <el-input class="form-input" v-model="form.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="项目类型" prop="manage_type">
            <el-radio  v-model="form.manage_type" :label="1">自营</el-radio>
            <el-radio  v-model="form.manage_type" :label="2">外拓</el-radio>
          </el-form-item>
          <el-form-item label="中奥项目" v-if="form.manage_type==1">
            <!-- <el-input class="form-input" :readonly="true" v-model="form.project_name" autocomplete="off"></el-input> -->
            <el-select  v-model="search.type_id" filterable placeholder="选择分类" clearable size="mini">
              <el-option
                v-for="(item,index) in search.type_list"
                :key="index"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
            <el-select v-model="search.region" placeholder="请选择战区" filterable clearable size="mini">
              <template v-for="item in search.region_list">
                <el-option :label="item.name" :value="item.id"/>
                <template v-for="sub in item.children">
                  <el-option :label="'  - ' + sub.name" :value="sub.id" />
                </template>
              </template>
            </el-select>
            <el-select  v-model="search.project" placeholder="请选择项目"  filterable clearable size="mini">
              <template v-for="(item,index) in search.project_list">
                <el-option :label="item.house_name" :value="item.erp_pindex_id"></el-option>
              </template>
            </el-select>

          </el-form-item>
          <el-form-item label="用友编码" prop="title">
            <el-input class="form-input" v-model="form.number" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="是否有其他组织架构">
            <el-switch
              v-model="form.has_extra_areas"
              active-text="是"
              inactive-text="否"
              @change="onHasExtraAreasChange"
            >
            </el-switch>
          </el-form-item>
          <el-form-item label="所属区域" >
            <!-- 单区域模式 -->
            <SelectContractArea 
              v-if="!form.has_extra_areas" 
              :area_ids="form.contract_area_ids" 
              @onAreaChange="onContractAreaChange" 
              :pid="0" 
            />
            
            <!-- 多区域模式 -->
            <div v-else>
              <div style="margin-bottom: 10px;">
                <span style="font-weight: bold;">主区域：</span>
                <SelectContractArea 
                  :area_ids="form.contract_area_ids" 
                  @onAreaChange="onContractAreaChange" 
                  :pid="0" 
                />
              </div>
              <div>
                <span style="font-weight: bold;">额外区域：</span>
                <SelectContractAreaMulti 
                  :area_ids="form.extra_area_ids" 
                  @onAreaChange="onExtraAreaChange" 
                />
              </div>
            </div>
          </el-form-item>
          <!-- <el-form-item label="用友编码" >
            <el-input class="form-input" v-model="form.yy_code" autocomplete="off"></el-input>
          </el-form-item> -->
          <el-form-item label="项目人数" prop="title">
            <el-input class="form-input" v-model="form.project_personnel_number" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="税率">
            <el-select v-model="form.tax_rate">
              <el-option :value="1" label="1%">1%</el-option>
              <el-option :value="3" label="3%">3%</el-option>
              <el-option :value="6" label="6%">6%</el-option>
              <el-option :value="9" label="9%">9%</el-option>
              <el-option :value="13" label="13%">13%</el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="服务面积" prop="title">
            <el-input class="form-input" v-model="form.service_area" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="省市" prop="title">
            <SelectArea :area_ids="form.province_city_ids" @onAreaChange="onAreaChange" :pid="0" :level="2"  />
          </el-form-item>
          <el-form-item label="项目地址" prop="title">
            <el-input class="form-input" v-model="form.address" autocomplete="off"></el-input>
          </el-form-item>

          <el-form-item label="项目负责人" prop="title">
            <el-input class="form-input" v-model="form.project_leader" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="负责人电话" prop="title">
            <el-input class="form-input" v-model="form.project_tell" autocomplete="off"></el-input>
          </el-form-item>

          <el-form-item label="进场时间" prop="title">
            <el-date-picker
              v-model="form.mobilization_time"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>

          <el-form-item label="附件" prop="title">
            <upload-files-sysc :host-url="host_url" :upload-url="host_url+'/contract/project/uploadFile'"  :limit="20" v-model="form.project_files"></upload-files-sysc>
          </el-form-item>

          <el-form-item label="备注" prop="title">
            <el-input
              type="textarea"
              placeholder="请输入内容"
              v-model="form.remarks"
              maxlength="100"
              show-word-limit
            >
            </el-input>
          </el-form-item>

        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" >确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="导入错误提示" :visible.sync="error_show_status" :close-on-click-modal="false" width="800px">
      <div style="max-height: 500px;overflow-y: auto;">
        <el-table
          :data="error_list"
          style="width: 100%">
          <el-table-column
            prop="id"
            label="ID"
            width="50">
          </el-table-column>
          <el-table-column
            prop="position"
            label="错误位置"
            width="120">
          </el-table-column>
          <el-table-column
            prop="error"
            label="错误信息">
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

  </div>
</template>

<script>

import CommonHelp from "./common/CommonHelp";
import UploadFilesSysc from "./components/UploadFilesSysc";
import AreaTree from "./components/AreaTree";
import SelectArea from "./components/SelectArea";
import SelectContractArea from "./components/SelectContractArea";
import SelectContractAreaMulti from "./components/SelectContractAreaMulti";
import UserProjectInfo from "../Butler/common/UserProjectInfo";

export default {
  name:"ContractProject",
  components: {SelectContractAreaMulti, SelectContractArea, SelectArea, AreaTree, UploadFilesSysc},
  data () {
    return {
      host_url:"",
      keyword: '',
      manage_type: "",
      manage_typeList: [{id:1,name:'自营'},{id:2,name:'外拓'}],
      loading: false,
      contract_area_id:'',
      search: {
        region:'',
        region_list: [],
        project:'',
        project_list:[],
        area:'',
        area_list:'',
        project_ids:'',
        type_id:'',
        type_list : []
      },
      pageData:{
        list:[],
        total:0,
        pageSize:20,
        page:1
      },
      pageChannelData:{
        list:[],
        total:0,
        pageSize:20,
        page:1
      },
      dialogVisible:false,
      form:{
        name:"",
        number:"",
        contract_area_ids:"",
        contract_area:"",
        extra_area_ids:"",
        has_extra_areas:false,
        entry_type:"",
        project_personnel_number:"",
        service_area:"",
        province_city:"",
        province_city_ids:"",
        province_id:"",
        city_id:"",
        address:"",
        project_leader:"",
        project_tell:"",
        mobilization_time:"",
        project_files:"",
        remarks:"",
        manage_type:2,
        project_id:"",
        project_name:"",
        tax_rate: 6,
      },
      uploadUrl:"",
      month_money_list:[],
      project_list:[],
      error_list:[],
      error_show_status:false,
      projectRegion:[],
      projectList:[],
      areaList:[],
      regionListKeyById: {},
    }
  },
  created() {
    this.host_url=CommonHelp.getBaseURL();
    // this.getList()
  },
  activated() {
    this.search.type_id = 1
    let that = this
    UserProjectInfo.ready(function(){
      that.search.type_list=UserProjectInfo.getTypeList();
      that.search.region_list = UserProjectInfo.getRegionList(that.search.type_id);
    },1)

    this.getList()
  },
  watch: {
    'search.type_id':function(newValue) {
      this.search.region = ''
      this.search.project = ''
      this.search.area = ''
      if (newValue === "") {
        this.search.region_list = []
        this.search.project_list = []
        this.search.area_list = []
      } else {
        this.search.region_list = UserProjectInfo.getRegionList(newValue);
      }

      this.search.project_ids = UserProjectInfo.getProjectIds(0,newValue)
      this.getList()

    },
    'search.region':function(newValue) {
      this.search.project = ''
      this.search.area = ''
      if (newValue === "") {
        this.search.project_list = []
        this.search.area_list = []
      } else {
        this.search.project_list=UserProjectInfo.getProjectList(this.search.region,this.search.type_id);
      }

      this.search.project_ids = UserProjectInfo.getProjectIds(this.search.region,this.search.type_id)
      this.getList()
    },
    'search.project':function(newValue) {
      this.search.area = ''
      if (newValue === "") {
        this.search.area_list = []
        this.search.project_ids = UserProjectInfo.getProjectIds(this.search.region,this.search.type_id)
      } else {
        this.search.project_ids = newValue
        // this.search.area_list = UserProjectInfo.getAreaList(newValue);
      }
      this.getList()
    },

    dialogVisible(val) {
      if(val == false) {
        // this.fileList = []
      }
    },
    "form.province_city_ids":function (n) {
      n&&n[0]&&(this.form.province_id=n[0])
      n&&n[1]&&(this.form.city_id=n[1])
      console.log(n)
    },
    "form.contract_area_ids":function (n) {
      console.log(n)
    }

  },
  methods: {
    getFormData(data) {
      return Object.assign({
        id:'',
        name:"",
        number:"",
        contract_area_ids:"",
        contract_area:"",
        entry_type:"",
        project_personnel_number:"",
        service_area:"",
        province_city:"",
        province_city_ids:"",
        province_id:"",
        city_id:"",
        address:"",
        project_leader:"",
        project_tell:"",
        mobilization_time:"",
        project_files:"",
        remarks:"",
        manage_type:2,
        project_id:"",
        project_name:"",
        yy_code:"",
        tax_rate : 6,
      }, data)
    },
    searchData() {
      this.pageData.page = 1
      this.getList()
    },
    getList() {
      var that=this;
      that.loading=true;
      let where={};
      this.keyword&&(where.name=this.keyword);
      this.contract_area_id&&(where.contract_area_ids=this.contract_area_id);
      this.manage_type&&(where.manage_type=this.manage_type);

      if (this.search.project_ids == '') {
        let projectIds = [];
        for (const k in this.search.region_list) {
          let item = this.search.region_list[k]
          let list = this.getProjectListByRegion(item.id)
          projectIds.push(list.map(item => item.erp_pindex_id))
        }
        where.project_id = projectIds.join(',');
      }else{
        where.project_id = this.search.project_ids
      }
      if(that.search.type_id) {
        where.type_id = that.search.type_id
      }else{
        where.type_id = ''
      }


      CommonHelp.get("Project/getList",{
        where:JSON.stringify(where),
        page: this.pageData.page,
        page_size: this.pageData.pageSize
      },res=>{
        if(res.code) {
          that.pageData=res.data
        }
        that.loading=false;
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    editArticle(item) {

      if(!item) {
        this.form = this.getFormData({})
        this.dialogVisible = true

      } else {
        this.form = Object.assign({}, item)
        // 获取额外区域信息
        if (item.id) {
          CommonHelp.get('Project/getProjectExtraAreas', {project_id: item.id}, res => {
            if (res.code === 1 && res.data && res.data.length > 0) {
              // 新接口返回的是数组，每个元素包含 area_ids(完整路径) 和 contract_area(路径名称)
              // 例如: [{area_ids: "1,36,125", contract_area: "集团 -> 广东 -> 深圳"}, ...]
              this.form.extra_areas_detail = res.data;  // 保存详细信息
              // 提取所有区域的完整路径ID，用特殊分隔符（如分号）分隔
              const extraAreaIds = res.data.map(area => area.area_ids).join(';');
              this.form.extra_area_ids = extraAreaIds;
              // 如果有额外区域，自动开启多区域模式
              if (extraAreaIds) {
                this.form.has_extra_areas = true;
              }
            }
            this.dialogVisible = true
          })
        } else {
          this.dialogVisible = true
        }
      }

    },

    getRegionList() {
      let that = this
      Http.get(Http.getFlowBaseURL() + "/hrm/User/getUserProjectInfo", {'status':0}, res => {
        if (res.code == 0) {
          that.projectRegion = this.getRegionTree(0, res.data.region_list)
          that.projectList = res.data.project_list
          that.areaList = res.data.area_list

          for (const k in res.data.region_list) {
            this.regionListKeyById[res.data.region_list[k]['id']] = res.data.region_list[k];
          }

          that.search.region_list = this.getRegionTree(0, res.data.region_list)
          this.getRepairList()
        }
      });
    },
    // 获取战区项目列表
    getProjectListByRegion(projectRegionId) {
      if (projectRegionId) {
        const regionItem = this.getRegion(projectRegionId)
        return this.projectList.filter(item => regionItem.pindex_id.includes(item.erp_pindex_id + ''))
      } else {
        return this.projectList
      }
    },
    getRegion(id) {
      return this.regionListKeyById[id];
    },
    getProject(id) {
      let projectList = this.projectList
      for (const k in projectList) {
        if (projectList[k].erp_pindex_id == id) {
          return projectList[k]
        }
      }
    },
    getProjectIds(data){
        let project_id = '';
        if(data.project) {
          project_id = data.project
        } else {
          if(data.region) {
            const list = this.getProjectListByRegion(data.region)
            project_id = list.map(item => item.erp_pindex_id).join(',')
          } else {
            project_id = this.projectList.map(item => item.erp_pindex_id).join(',')
          }
        }
        return project_id;
    },

    submitForm(formName) {
      CommonHelp.get("Project/getProject",{project_id:this.search.project_ids, manage_type: this.form.manage_type},res => {
        if(res.code==200) {
          this.form.project_id = res.data.id

          var that=this;
          that.$refs[formName].validate((valid) => {
            if (valid) {
              that.formLoading = true
              let data = Object.assign({}, this.form)
              CommonHelp.post("Project/save",data,res => {
                that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
                if(res.code) {
                  that.dialogVisible = false
                  that.getList()
                }
                that.formLoading = false
              })
            } else {
              return false;
            }
          });

        }else{
          this.$message({type:'error', message: res.msg})
        }
      })
    },

    setFrom(data){
      var that=this;
      CommonHelp.post("Project/save",data,res => {
        that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
        if(res.code) {
          that.getList()
        }
      })
    },
    onAreaChange({data,pathData,ids}){
      this.form.province_city=data.mergename;
      this.form.province_city_ids=ids.join(',')
    },
    onContractAreaChange({data,pathData,ids}){
      let adrr=""
      pathData.map((ret,index)=>{
        adrr+=ret.name+(pathData[index+1]?' -> ':'')
      })
      this.form.contract_area=adrr;
      this.form.contract_area_ids=ids.join(',')
    },
    // Switch 开关变化事件
    onHasExtraAreasChange(val) {
      if (!val) {
        // 关闭多区域模式时，清空额外区域
        this.form.extra_area_ids = '';
      }
    },
    // 额外区域选择变化事件
    onExtraAreaChange(area_ids_str) {
      this.form.extra_area_ids = area_ids_str;
    },
    deleteProject(item){
      var that=this;
      CommonHelp.post("Project/delete", {id:item.id},res => {
        that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
        if(res.code) {
          that.getList()
        }
      })
    },
    nodeClick1(n){
      this.contract_area_id=n.id;
      this.pageData={
        list:[],
        total:0,
        pageSize:20,
        page:1
      }
      this.getList()
    },
    exportExcel(){
      var that=this;
      let where={};
      this.keyword&&(where.name=this.keyword);
      this.contract_area_id&&(where.contract_area_ids=this.contract_area_id);
      this.manage_type&&(where.manage_type=this.manage_type);

      if (this.search.project_ids == '') {
        let projectIds = [];
        for (const k in this.search.region_list) {
          let item = this.search.region_list[k]
          let list = this.getProjectListByRegion(item.id)
          projectIds.push(list.map(item => item.erp_pindex_id))
        }
        where.project_id = projectIds.join(',');
      }else{
        where.project_id = this.search.project_ids
      }
      if(that.search.type_id) {
        where.type_id = that.search.type_id
      }else{
        where.type_id = ''
      }


      CommonHelp.get("Project/exportExcel",{
        where:JSON.stringify(where),
        page: this.pageData.page,
        page_size: this.pageData.pageSize
      },res=>{
        if(res.code) {
          window.open(that.host_url + res.data)
        }
      })
    },
    importExcel(){
      var that=this;
      CommonHelp.uploadFile(ret=>{
        // console.log(ret);
        CommonHelp.post("Project/importExcel",{ file_name:ret },res=>{
          if(res.code) {
            that.getList();
            if(res.data&&res.data.length){
              that.error_show_status=true;
              that.error_list=res.data;
            }
          }else {
            this.$message(res.msg);
          }
        })
      });
    }
  }
}
</script>
<style lang="scss" scoped>

@import './common.scss';

.form-input {
  width: 300px;
}
.table-wrap{
  width: calc( 100vw - 120px - 230px );
  overflow-x: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Contract/ContractProject.vue